import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsPauseHighlightedMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M4 3.75C4 2.783 4.784 2 5.75 2h5.5c.967 0 1.75.783 1.75 1.75v24.5A1.75 1.75 0 0111.25 30h-5.5A1.75 1.75 0 014 28.25zM19 3.75c0-.967.783-1.75 1.75-1.75h5.5c.967 0 1.75.783 1.75 1.75v24.5A1.75 1.75 0 0126.25 30h-5.5A1.75 1.75 0 0119 28.25z" />
      </g>
    </svg>
  )
);
SvgActionsPauseHighlightedMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsPauseHighlightedMedium;
